import { Marker, Source, Layer } from '@vis.gl/react-maplibre';
import { useEditMode } from '../../store/editMode';
import { useSelection } from '../../store/selection';
import { santaColomaIntersections } from '../../data/santa-coloma';

/**
 * Feedback visual de Modo Edición mientras se reposiciona un regulador:
 * línea entre la posición vieja y la candidata + marker ámbar en la nueva.
 * A los niveles de zoom del municipio completo, un desplazamiento de pocos
 * metros es difícil de juzgar sin esta referencia.
 */
export function EditGhostOverlay() {
  const active = useEditMode(s => s.active);
  const pendingCoord = useEditMode(s => s.pendingCoord);
  const selectedId = useSelection(s => s.selectedId);

  if (!active || !pendingCoord || selectedId === null) return null;
  const ix = santaColomaIntersections.find(i => i.cabinet.logicalId === selectedId);
  if (!ix) return null;

  const line: GeoJSON.Feature<GeoJSON.LineString> = {
    type: 'Feature',
    properties: {},
    geometry: { type: 'LineString', coordinates: [ix.cabinet.position, pendingCoord] },
  };

  return (
    <>
      <Source id="edit-ghost-line" type="geojson" data={line}>
        <Layer
          id="edit-ghost-line-layer"
          type="line"
          paint={{ 'line-color': '#f59e0b', 'line-width': 2, 'line-dasharray': [2, 2] }}
        />
      </Source>
      <Marker longitude={pendingCoord[0]} latitude={pendingCoord[1]} anchor="center">
        <div className="w-4 h-4 rounded-full bg-amber-400 border-2 border-white shadow-lg" />
      </Marker>
    </>
  );
}
